import { useAuth0 as useReactAuth0 } from '@auth0/auth0-react';

let _mockAuth0User: any;

function getAccessTokenSilently(): Promise<any> {
  return Promise.resolve('tokenSilent');
}

/**
 * Transparent wrapper around the original useAuth0 hook to be able to mock the user in tests.
 * This is a temporary solution until we are able to properly stub imports in Cypress.
 */
const useAuth0 = (): any => {
  const auth0 = useReactAuth0();
  // deepcode ignore CompareTypeofToString: Comparing to undefined because action is made according to its state
  if (window.hasOwnProperty('Cypress') && typeof _mockAuth0User !== undefined) {
    auth0.user = _mockAuth0User;
    auth0.getAccessTokenSilently = getAccessTokenSilently;
  }
  return auth0;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setMockAuth0User = (user?: any): void => {
  if (window.hasOwnProperty('Cypress')) {
    _mockAuth0User = user;
  } else {
    // eslint-disable-next-line no-console
    console.error('Cannot call this function outside test environment');
  }
};

export default useAuth0;
